<template>
    <div>
        <h1>Configurações do Jogo</h1>
    </div>
</template>
<script>
export default {
    name:'Settings'
}
</script>